import React, { useState } from 'react';
import {
  shareBlogViaWhatsApp,
  shareBlogViaFacebook,
  shareBlogViaInstagram,
  copyBlogLink,
} from '../utils/blogUtils';
import { trackBlogShare } from '../utils/analytics';
import './BlogShareBar.css';

const BlogShareBar = ({ post, compact = false }) => {
  const [feedback, setFeedback] = useState('');

  if (!post?.slug) {
    return null;
  }

  const showFeedback = (message) => {
    setFeedback(message);
    setTimeout(() => setFeedback(''), 2500);
  };

  const handleWhatsApp = () => {
    trackBlogShare('whatsapp', post);
    shareBlogViaWhatsApp(post);
  };

  const handleFacebook = () => {
    trackBlogShare('facebook', post);
    shareBlogViaFacebook(post);
  };

  const handleInstagram = async () => {
    trackBlogShare('instagram', post);
    const result = await shareBlogViaInstagram(post);
    if (result.copied) {
      showFeedback('Copied — paste in the Instagram app');
    } else {
      showFeedback('Copy the link manually to share on Instagram');
    }
  };

  const handleCopyLink = async () => {
    trackBlogShare('copy_link', post);
    const ok = await copyBlogLink(post);
    showFeedback(ok ? 'Link copied!' : 'Could not copy link');
  };

  return (
    <div className={`blog-share-bar${compact ? ' blog-share-bar--compact' : ''}`}>
      {!compact && <span className="blog-share-bar__label">Share this post</span>}
      <div className="blog-share-bar__actions">
        <button type="button" className="btn btn-whatsapp blog-share-bar__btn" onClick={handleWhatsApp}>
          <span>📱</span> WhatsApp
        </button>
        <button type="button" className="btn btn-facebook blog-share-bar__btn" onClick={handleFacebook}>
          <span>📘</span> Facebook
        </button>
        <button type="button" className="btn btn-instagram blog-share-bar__btn" onClick={handleInstagram}>
          <span>📷</span> Instagram
        </button>
        <button type="button" className="btn btn-secondary blog-share-bar__btn" onClick={handleCopyLink}>
          Copy link
        </button>
      </div>
      {feedback && <p className="blog-share-bar__feedback">{feedback}</p>}
    </div>
  );
};

export default BlogShareBar;
